export class StopPlacesInsertFailed extends Error {}
